<script setup>
import auth from '@/commons/authService.js';
import { getCurrentInstance, inject } from 'vue';
import { useManual } from '@/setup/manualComposition.js';
import socketInstance from '@/commons/socket.js';

const { proxy } = getCurrentInstance();
//nếu có sesstion thì connect vào socket
// Nên là
const currentPath = window.location.pathname;
if (
  auth.isAuthenticated() &&
  !currentPath.includes('/privacy') &&
  !currentPath.includes('/thirdparty')
) {
  socketInstance.connectSocket(proxy);
}
</script>
<template>
  <div id="app">
    <survey-customer />
    <router-view />
    <AgreementAndPrivacyPopup />
    <div id="message-box" style="z-index=101">
      <MsToastMsgNotify />
      <MsDebtInvoiceNotify
        :is-show-debt-invoice-popup="isShowDebtInvoice"
        :debt-invoices="debtInvoices"
        @onClose="onCloseDebtInvoice"
      />
    </div>
    <div v-if="auth.isAuthenticated()" id="export-box">
      <MsExportProcess />
    </div>
    <live-chat
      v-if="auth.isAuthenticated()"
      :drag-live-chat-btn="dragLiveChatBtn"
      @changeDragLiveChatBtn="changeDragLiveChatBtn"
      @showTourliveChat="showTourliveChat"
    />
    <div id="mloading" class="loading">
      <div class="loading-cover" />
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <modals-container />
    <popovers-container />
    <ms-popover-container />
    <dialog-wrapper />
    <manual-floating-btn
      v-if="isShowFloatingBtn && proxy.$route.path != '/dashboard/start-use'"
    />
    <ms-tour-guide />
    <div id="aibot"></div>
  </div>
</template>

<script>
import { DialogWrapper } from 'vue3-promise-dialog';
import MsPopoverContainer from '@/components/popover/MsPopoverContainer.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { ModuleContext, ModuleDbOption } from '@/stores/moduleConst';
import theme from '@/assets/config/theme.js';
import popoverUtil from '@/commons/popoverUtil';
import organizationUnitAPI from '@/apis/eTask/organizationUnitAPI.js';
import MsToastMsgNotify from '@/components/ms-toast-msg-notify/MsToastMsgNotify.vue';
import MsDebtInvoiceNotify from '@/components/ms-toast-msg-notify/MsDebtInvoiceNotify.vue';
import MsExportProcess from '@/components/ms-export-process/MsExportProcess.vue';
import NotificationAPI from '@/apis/other/notificationAPI';
import FileAPI from '@/apis/other/fileAPI.js';
import ExportDynamicAPI from '@/apis/other/exportDynamicAPI.js';
import MsTourGuide from '@/components/ms-tour-guide/MsTourGuide.vue';
import ManualFloatingBtn from '@/components/manual-floating-btn/ManualFloatingBtn.vue';
import store from '@/stores/store';
import LiveChat from '@/views/livechat/LiveChat.vue';
import debtInvoiceAPI from '@/apis/eTask/debtInvoiceAPI';
import subscriberAPI from '@/apis/eTask/subscriberAPI';
import optionAPI from '@/apis/other/optionAPI';
import SurveyCustomer from '@/views/survey/SurveyCustomer.vue';
import avaApi from '@/apis/ava/avaApi';
import commonFn from '@/commons/commonFunction';
import AgreementAndPrivacyPopup from '@/components/popup/AgreementAndPrivacyPopup.vue';
export default {
  components: {
    DialogWrapper,
    MsPopoverContainer,
    MsToastMsgNotify,
    MsExportProcess,
    MsTourGuide,
    ManualFloatingBtn,
    MsDebtInvoiceNotify,
    LiveChat,
    SurveyCustomer,
    AgreementAndPrivacyPopup,
  },
  data() {
    return {
      theme: this.$store.state?.context?.Theme,
      dragLiveChatBtn: null,
      isShowDebtInvoice: false,
      debtInvoices: [],
      avaConnectionInfo: null,
      isInitAVA: false,
      avaCache: {
        functionCalling: '',
        param: null,
        student: null,
      },
    };
  },
  computed: {
    ...mapState('context', ['Theme', 'User']),
  },
  watch: {
    Theme(val) {
      this.changeTheme(val);
    },
    User(val) {
      this.checkDebtInvoice();
    },
  },
  created() {
    this.getSubscriberInfo();
  },
  mounted() {
    const me = this;
    const currentPath = window.location.pathname;
    // Chỉ thực hiện các API calls nếu không ở trang privacy
    if (
      !currentPath.includes('/privacy') &&
      !currentPath.includes('/thirdparty')
    ) {
      me.initEventHoverUser();
      me.runExportProcess();
      me.initAva();
    }
  },
  methods: {
    /**
     * Khơi tạo AVA
     */
    initAva() {
      /** Luồng AVA:
       * B1: Check xem đã khởi tạo AVA chưa ?  (Cắm 1 cờ đề biết đã khởi tạo chưa)
       *   B2.1: AVA đã khởi tạo -> hiển thị luôn
       *   B2.2: AVA chưa khởi tạo -> Gọi API lấy thông thin kết nối, sau đó khởi tạo AVA
       */
      var me = this;

      me.resetCacheAvaParam();
      me.widthVpMainNoAVA = document.getElementById('app').offsetWidth;

      if (me.isInitAVA) {
        // Khởi tạo session mới
        window._aiBot._config.sessionId = commonFn.generateUUID();
        window._aiBot.show();

        setTimeout(function () {
          me.setWithVpMainWhenOpenAva();
        }, 500);

        return;
      }

      me.isInitAVA = true;
      me.getAVAConnection();
    },
    /**
     * reset cache
     */
    resetCacheAvaParam() {
      var me = this;

      me.avaCache = {
        functionCalling: '',
        param: null,
      };
    },
    /**
     * Hàm connect đến AVA
     */
    async getAVAConnection() {
      var me = this;

      try {
        if (me.avaConnectionInfo == null) {
          var res = await avaApi.getConnectAVA();
          me.avaConnectionInfo = res;
          me.initAvaLoader();
        } else {
          // lấy session ID mới khi F5 hoặc tắt đi bật lại để tránh lưu lịch sử vào đoạn chat trước đó
          me.avaConnectionInfo.sessionId = commonFn.generateUUID();
        }
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * Khởi nhúng file js AVA, khởi tạo AVA
     */
    initAvaLoader() {
      var me = this;

      if (me.avaConnectionInfo == null) {
        return;
      }

      var el = document.createElement('script');
      el.src = `${me.avaConnectionInfo.baseUrl}/avaLoader.js`;
      el.type = 'text/javascript';

      el.onload = function () {
        try {
          // customAiBotConfig(me.avaConnectionInfo);

          // Chỉ hiển thị những chức năng cần thiết
          const optionDisplays = ['chatbot'];
          me.avaConnectionInfo.avaConfig = Array.from(
            me.avaConnectionInfo.avaConfig
          ).filter(function (e) {
            // if (e.FeatureCode == "command") {
            //   e.FeatureName = "Thao tác nhanh";
            //   e.Description = "Lập đợt thu, thông báo thu tiền, thu tiền...";
            // }

            return optionDisplays.includes(e.FeatureCode);
          });

          let config = me.getAiBotConfig();

          for (let i in me.avaConnectionInfo) {
            config[i] = me.avaConnectionInfo[i];
          }
          //Khai báo hàm xử lý refresh token khi gặp lỗi 401
          config.refreshToken = me.refreshAVAConnection.bind(me);

          //Khai báo 1 số xử lý đặc thù của dự án nếu có
          //   config.fnAfterShow = me.fnAfterShow;
          //   config.fnAfterHide = me.fnAfterHide;
          config.fnAfterShow = function () {};
          config.fnAfterHide = function () {};
          // Hàm này trong aib.js
          window.initAiBot(config).then((res) => {
            window._aiBot = res;

            //Chỉ định hàm xử lý nghiệp vụ
            //Sau khi phân tích được ý định của người dùng aibot sẽ gọi hàm này về dự án để xử lý nghiệp vụ
            // window._aiBot.callJs = me.processBusiness;
            // window._aiBot.customBotChatRender = me.customBotChatRender;
            // window._aiBot.buildHomeHelloChat = me.buildHomeHelloChat;
            window._aiBot.afterClosePopup = me.afterClosePopup.bind(me);
            window._aiBot.afterMinPopup = me.afterMinAVAPopup;
            // window._aiBot.customAfterMousemoveResizePopup =
            //   me.customAfterMousemoveResizeAVAPopup;
            // window._aiBot.customItemRenderQuickReplies = me.customItemRenderQuickReplies;
            // window._aiBot.itemClick = me.itemClick;
            window._aiBot.customAfterMousemoveResizePopup =
              me.customAfterMousemoveResizePopup.bind(me);
            setTimeout(function () {
              me.setWithVpMainWhenOpenAva();
            }, 500);
            //hiển thị chatbot
            // window._aiBot.show();
          });

          //window._aiBot.openLiveChat = openLiveChat; // callback function để mở liveChat
          //window._aiBot.customDataLiveChat = customDataLiveChat; // callback function để custom lại tham số LiveChat
        } catch (ex) {
          console.log(ex);
        }
      };

      document.head.appendChild(el);
    },
    /**
     * sự kiện thu popup ava thu nhỏ
     * @param {any} isMin
     * @param {any} $el
     */
    afterMinAVAPopup: function (isMin = false, $el) {
      if (!isMin) {
        return;
      }

      var me = this;
      const element = document.getElementById('app');
      element.style.width = `${me.widthVpMainNoAVA}px)`;
      // me.vpMain.setWidth(me.widthVpMainNoAVA);
    },
    /**
     * Hàm reset connect đến AVA
     */
    refreshAVAConnection() {
      const self = this;
      return new Promise(async function (resolve, reject) {
        var result = await avaApi.getConnectAVA();
        if (result) {
          self.avaConnectionInfo = result;
          // Chỉ hiển thị những chức năng cần thiết
          const optionDisplays = ['chatbot'];
          self.avaConnectionInfo.avaConfig = Array.from(
            self.avaConnectionInfo.avaConfig
          ).filter(function (e) {
            return optionDisplays.includes(e.FeatureCode);
          });
          resolve(self.avaConnectionInfo);
        } else {
          resolve(null);
        }
      });
    },
    /**
     * Lấy config truyền xuống AVA
     */
    getAiBotConfig() {
      var user = this.$store.state?.context?.User;
      var userId = user.MISAID ? user.UserID : user.UserID,
        // name = MISA.ContextData.CurentUserFullName,
        // currentAccountArchive = localStorage.getItem('CurrentAccountArchive'),
        avatarUrl = user.AvatarUrl,
        name = user.FullName;

      var config = {
        user: {
          id: userId,
          name: name,
          gender: 1, // 0.Unknown 1.Nam 2.Nữ
          avatar: avatarUrl,
        },
      };

      return config;
    },
    /**
     * Xét width cho app khi mở AVA
     */
    setWithVpMainWhenOpenAva() {
      var aibotElement = document.getElementById('aibot');

      if (aibotElement) {
        const appWidth = aibotElement.getBoundingClientRect().width || 0;
        const element = document.getElementById('app');
        element.style.width = `calc(${this.widthVpMainNoAVA} - ${appWidth}px)`;
      }
    },
    customAfterMousemoveResizePopup: function (isResizing, el, widthx) {
      if (!isResizing) {
        return;
      }

      const element = document.getElementById('app');
      element.style.width = `calc(${this.widthVpMainNoAVA} - ${widthx}px)`;
    },
    /**
     * Xử lý trước khi đóng AVA
     */
    afterClosePopup(isClose = false, $el) {
      if (!isClose) {
        return;
      }
      const element = document.getElementById('app');
      element.style.width = `${this.widthVpMainNoAVA}px)`;
    },
    /**
     * Get theme cho button
     * LMDuc 07.11.2022
     */
    changeTheme(key) {
      let themeConfig = theme[key];

      if (!themeConfig) return;

      for (const key in themeConfig) {
        document.documentElement.style.setProperty(key, themeConfig[key]);
      }
    },

    async getSubscriberInfo() {
      const me = this;

      if (!me.User?.OrganizationUnitCode) {
        return;
      }

      let res = JSON.parse(localStorage.getItem('subscriber_info'));
      if (!res) {
        res = await subscriberAPI.getSubscriberInfo(
          me.User?.OrganizationUnitCode
        );
        localStorage.setItem('subscriber_info', JSON.stringify(res));
      }

      let resource = JSON.parse(res.Resource);
      if (resource.Package.EndDate > new Date()) {
        me.$router.push('/expire');
      }
    },

    /**
     * Thực hiện kiểm tra điều kiện hiển thị thông báo có hóa đơn chưa thanh toán
     */
    async checkDebtInvoice() {
      //quản trị hệ thống thì check để hiển thị
      if (
        this.$store?.state?.context?.User?.IsAdmin &&
        window.isShowDebtInvoice
      ) {
        let budgetCode =
          this.$store?.state?.context?.User?.OrganizationUnitCode;
        let timeRemind;
        await optionAPI.getDbOptions('DebtInvoiceRemind').then((result) => {
          if (result) {
            timeRemind = result.OptionValue.TimeRemind;
          }
        });

        debtInvoiceAPI.getDebtInvoice(budgetCode).then((result) => {
          if (result.length > 0) {
            this.isShowDebtInvoice =
              commonFn.formatDate(new Date()) === timeRemind ||
              typeof timeRemind === 'undefined'
                ? true
                : false;
            this.debtInvoices = result;
          }
        });
      }
    },

    /**
     * Khi người dùng tắt thông báo thì thực hiện thêm vào option ngày hiển thị lại
     */
    onCloseDebtInvoice() {
      const today = new Date(); // Lấy ngày hôm nay
      const nextThreeDays = new Date(today); // Tạo một đối tượng Date mới từ ngày hôm nay
      nextThreeDays.setDate(today.getDate() + 3);

      optionAPI.updateDbOptions({
        model: {
          optionKey: 'DebtInvoiceRemind',
          optionValueType: 3,
          optionValue: {
            TimeRemind: commonFn.formatDate(nextThreeDays),
          },
        },
      });

      this.isShowDebtInvoice = false;
    },

    initEventHoverUser() {
      // eslint-disable-next-line no-undef
      $('body').on('mouseover', '.display-user-tooltip-global', function (e) {
        let target = e.currentTarget;
        if (!target.closest('.add-comment')) {
          // eslint-disable-next-line no-undef
          let userInfo = $(target).attr('data');
          while (typeof userInfo == 'string') {
            userInfo = JSON.parse(userInfo);
          }
          popoverUtil.show('DisplayUserTooltipGlobal', target, {
            targetElement: target,
            userInfo,
          });
        }
      });
      // eslint-disable-next-line no-undef
      $('body').on('mouseleave', '.display-user-tooltip-global', function (e) {
        if (!e.toElement.closest('.popover-display-user'))
          popoverUtil.hideAll();
      });
    },

    /**
     * chạy luồng xuất khẩu cho nếu tồn xuất khẩu trong storage
     * 1. nếu luồng nào success => xóa
     * 2. nếu false => chạy lại
     * created by lkphuc 09.03.2023
     */
    runExportProcess() {
      // let exportProcess = this.$store.state?.export;
      // if (exportProcess && exportProcess.hasOwnProperty("lstNameExport")) {
      //   for (let property in exportProcess.lstNameExport) {
      //     delete exportProcess.lstNameExport[property];
      //   }
      // }
    },

    changeDragLiveChatBtn(drag) {
      this.dragLiveChatBtn = drag;
    },
  },
};
</script>
<style>
#aibot {
  position: fixed;
  right: 0px;
  bottom: 0px;
  z-index: 9999999999;
  cursor: pointer;
}
</style>
